import {
  CheckCircleOutlined,
  ExclamationCircleOutlined,
  InfoCircleOutlined,
  WarningOutlined
} from "@ant-design/icons"
import React from "react"

import { type NotificationLevel } from "../types/notification.types.ts"

export const notificationsVariants: Record<
  NotificationLevel,
  { icon: React.ReactNode; color: string; bg: string }
> = {
  success: {
    icon: <CheckCircleOutlined style={{ fontSize: 18 }} />,
    color: "#52c41a",
    bg: "#f6ffed"
  },
  info: {
    icon: <InfoCircleOutlined style={{ fontSize: 18 }} />,
    color: "#1677ff",
    bg: "#e6f4ff"
  },
  warning: {
    icon: <WarningOutlined style={{ fontSize: 18 }} />,
    color: "#faad14",
    bg: "#fffbe6"
  },
  error: {
    icon: <ExclamationCircleOutlined style={{ fontSize: 18 }} />,
    color: "#ff4d4f",
    bg: "#fff2f0"
  },
  4: {
    icon: <ExclamationCircleOutlined style={{ fontSize: 18 }} />,
    color: "#ff4d4f",
    bg: "#fff2f0"
  }
}
